import { IMAGE_SERVER } from "../config";
import { Steps } from "../constants"
import { wizardStore } from "../stores/wizard"
import { ISizeStandard, StepOption } from "../types/wizard"

export function sizeStandardValidation(): boolean {
  const emblemData = wizardStore.emblemData
  const sizeStep = wizardStore.step;

  if (emblemData[Steps.SizeStandard]) {
    const sizeStandard: ISizeStandard = emblemData[Steps.SizeStandard]

    // Check if both height and width are provided or not empty
    const hasDimensions = sizeStandard.width && sizeStandard.height

    if (sizeStep.dimensionsConstraints && hasDimensions) {
      const constraints = sizeStep.dimensionsConstraints
      let invalidHeight = false, invalidWidth = false;

      if (sizeStandard.height && constraints.heightMax || constraints.heightMin) {
        const height = Number(sizeStandard.height)
        invalidHeight = height > constraints.heightMax || height < constraints.heightMin
      }

      if (sizeStandard.width && constraints.widthMax || constraints.widthMin) {
        const width = Number(sizeStandard.width)
        invalidWidth = width > constraints.widthMax || width < constraints.widthMin
      }

      if (invalidHeight || invalidWidth) {
        return true;
      }
    }

    // Check if scaleHeight is true and width is provided
    const validScaleHeight = sizeStandard.width && sizeStandard.scaleHeight
    
    // Check if scaleWidth is true and height is provided
    const validScaleWidth = sizeStandard.height && sizeStandard.scaleWidth
    
    // Validation passes if dimensions are provided and neither scaleHeight nor scaleWidth is invalid
    return !hasDimensions && !validScaleHeight && !validScaleWidth
  }
  return true
}

export function colorsValidation(stepId: string) {
  const emblemData = wizardStore.emblemData[stepId]
  const sizeStep = wizardStore.step;

  if (emblemData?.items && emblemData?.items?.length) {
    const totalColors = emblemData?.items?.length
    if (sizeStep.numberOfColorsAllowedMin && totalColors < sizeStep.numberOfColorsAllowedMin) {
      return true
    }

    if (sizeStep.numberOfColorsAllowedMax && totalColors > sizeStep.numberOfColorsAllowedMax) {
      return true
    }
  }

  return !emblemData;
}

export const getColorStyle = (color?: StepOption) => {
  return color?.image ? { backgroundImage: `url('${IMAGE_SERVER}${color?.image?.url}')`, backgroundSize: 'cover' } : { backgroundColor: color?.htmlColor || "transparent"}
}